export default __webpack_public_path__ + "static/media/watch.d4e2e86b.svg";